import React from "react";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment-timezone";
import { Badge } from "@material-ui/core";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const MockShortListColumn = (language, userinfo) => [
    {
        Header: language.CCMODE_SETUP_APPROVED_LISTNAME,
        accessor: "ListName",
        Cell: ({ value, row }) => {
            const d = row.original;
            return d.isBuyRequest > 0 ? (
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id={`tooltip-${d.id || Math.random()}`}>
                            you have {d.isBuyRequest} Buy Request(s) for this
                            list
                        </Tooltip>
                    }
                >
                    <Badge
                        color="secondary"
                        badgeContent={d.isBuyRequest}
                        invisible={false}
                    >
                        <span className="pr-3">{value}</span>
                    </Badge>
                </OverlayTrigger>
            ) : (
                <>{value}</>
            );
        },
        className: "align-middle text-center",
    },
    {
        Header: language.CCMODE_SESSION_NAME,
        accessor: "UserName",
        className: "align-middle text-center",
    },
    {
        Header: language.WISHLIST_DATE,
        accessor: "CreatedAt",
        Cell: (row) => (
            <>
                {row.value
                    ? moment
                          .tz(
                              row.value,
                              userinfo.timezone
                                  ? userinfo.timezone
                                  : Intl.DateTimeFormat().resolvedOptions()
                                        .timeZone
                          )
                          .format("YYYY-MM-DD HH:mm:ss")
                    : "-"}
            </>
        ),
        className: "text-center align-middle",
    },
    {
        Header: language.CCMODE_SETUP_APPROVED_NOSTONES,
        accessor: "ShortListedStones",
        className: "text-center align-middle",
    },
    {
        Header: language.SEARCHLIST_TOTALCARAT,
        // accessor:'Carats',
        accessor: (d) => {
            return (
                <>
                    <span className="text-primary"> {d.Carats.toFixed(2)}</span>
                </>
            );
        },
        className: "text-center align-middle",
    },
];
